<template>
  <div class="flashcard-footer">
    <button
      class="flashcard-footer-button"
      @click="handleHighlightClick"
    >
      <icon
        name="highlight"
        class="flashcard-footer-icon"
      ></icon>
      Highlight
    </button>
    <span class="spacer"></span>
    <button
      class="flashcard-footer-button"
      @click="handleBookmarkClick"
    >
      <icon
        v-if="hasBookmark"
        name="flag-filled"
        class="flashcard-footer-icon"
        data-test="flag-filled"
      ></icon>
      <icon
        v-else
        name="flag-outline"
        class="flashcard-footer-icon"
        data-test="flag-outlined"
      ></icon>
      Flag
    </button>
    <button
      v-if="previousFlashcardId"
      class="flashcard-footer-button"
      data-test="previous-button"
      @click="navigate(previousFlashcardId, 'previous')"
    >
      Prev
    </button>
    <button
      class="flashcard-footer-button"
      data-test="next-button"
      @click="navigate(nextFlashcardId, 'next')"
    >
      {{ nextText }}
    </button>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: {
    Icon,
  },
  props: {
    nextFlashcardId: {
      type: Number,
      required: false,
    },
    previousFlashcardId: {
      type: Number,
      required: false,
    },
    bookmark: {
      type: Object,
      required: false,
    },
    isSimulationComplete: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    hasBookmark() {
      return this.bookmark && !this.bookmark.deleted;
    },
    nextText() {
      if (this.nextFlashcardId) {
        return 'Next';
      }

      if (this.isSimulationComplete) {
        return 'Section Review';
      }

      return 'Submit Section';
    },
  },
  methods: {
    navigate(nextFlashcardId, button) {
      this.$emit('navigate', nextFlashcardId, button);
    },
    handleBookmarkClick() {
      this.$emit('toggleBookmark');
    },
    handleHighlightClick() {
      this.$emit('clickHighlight');
    },
  },
};
</script>

<style lang='scss' scoped>
.flashcard-footer {
  display: flex;
  height: 3.5rem;
  gap: 3rem;
  padding-left: 3rem;
  padding-right: 3rem;
  align-items: center;
  border-top: 1px solid #D9D9D9;

  .spacer {
    flex-grow: 1;
  }

  .flashcard-footer-button {
    display: flex;
    background-color: white;
    font-size: 20px;
    height: 20px;
    line-height: 20px;
    font-weight: 600;
  }

  .flashcard-footer-icon {
    display: inline;
    height: 18px;
    margin-right: 0.5rem;
  }

  .flagged {
    background-color: yellow;
  }
}
</style>
